import { render, staticRenderFns } from "./PDFJSViewer.vue?vue&type=template&id=f2e12d84&scoped=true"
import script from "./PDFJSViewer.vue?vue&type=script&lang=js"
export * from "./PDFJSViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e12d84",
  null
  
)

export default component.exports